import React, { useEffect, useState } from "react"
import DataTable from "react-data-table-component"
import { ChevronDown, ChevronLeft, ChevronRight, RotateCw } from "react-feather"
import ReactPaginate from "react-paginate"
import { connect } from "react-redux"
import { tokenSelector } from "../../redux/selectors"
import fetchApi from "../../utility/context/fetchApi"
import notify from "../../utility/context/notify"
import { comparators, getSliceData, getSortIndex, getTotalPages, typeDate, typeString } from "./utils"
import { typeNumber } from "./utils"

const ActionsComponent = ({ row, activatePayment }) => {
    return (
        <div className="data-list-action minus-6">
            <RotateCw
                className="cursor-pointer control-icon"
                size={20}
                title='Activate subsciption'
                onClick={() => {
                    activatePayment(row)
                }}
            />
        </div>
    )
}

const spanStyle = { maxWidth: '150px', overflow: "hidden", whiteSpace: 'nowrap', textOverflow: 'ellipsis' }

function AffiliatePagePayments(props) {
    const [data, setData] = useState([])
    const [total, setTotal] = useState(1)
    const [page, setPage] = useState(0)
    const [limit, setLimit] = useState(5)
    const [totalPages, setTotalPages] = useState(1)
    const [sortIndex, setSortIndex] = useState([1, 2])
    const [filter, setFilter] = useState('')
    const [sort, setSort] = useState({ selector: 'createdAt', type: 'asc', typeData: typeDate })

    useEffect(() => {
        if (props.dataAll) {
            const allDataSorted = props.dataAll.slice().sort(comparators[sort.typeData](sort.selector))
            if (sort.type === 'asc') allDataSorted.reverse()
            if (filter) {
                const filteredData = allDataSorted
                    .filter((row) =>
                        (row.email && row.email.toLowerCase().includes(filter.toLowerCase())) ||
                        (row.promocode && row.promocode.toLowerCase().includes(filter.toLowerCase())) ||
                        (row.name && row.name.toLowerCase().includes(filter.toLowerCase())) ||
                        (row.method && row.method.toLowerCase().includes(filter.toLowerCase())) ||
                        (row.type && row.type.toLowerCase().includes(filter.toLowerCase()))
                    )
                setData(filteredData)
                setTotal(filteredData.length)
                setTotalPages(1)
                setPage(0)
                setSortIndex([1, filteredData.length])
            } else {
                setData(getSliceData(allDataSorted, page, limit))
                setTotal(allDataSorted.length)
                setTotalPages(getTotalPages(allDataSorted, limit))
                setSortIndex(getSortIndex(page, limit, allDataSorted.length))
            }
        }
    }, [page, props.dataAll, limit, filter, sort])

    const activatePayment = (row) => {
        fetchApi({
            url: `/affiliate/${row._id}`,
            method: 'PATCH',
            token: props.token,
            body: { ...row, paid: true }
        }).then((payment) => {
            props.setDataAll(props.dataAll.map((node) => {
                if (node._id === payment._id) return payment
                return node
            }))
            notify('Payment done.')
        })
    }

    const handleSort = ({ selector, type: typeData }, type) => {
        setSort({ selector, type, typeData })
    }

    const columns = [
        {
            name: 'Date',
            type: typeDate,
            selector: "date",
            flexGrow: 1,
            cell: row => {
                const date = (row.date && new Date(row.date)) || new Date()
                return <span>{new Intl.DateTimeFormat('en-EN', { year: 'numeric', month: 'short' }).format(date)}</span>
            }
        },
        {
            name: 'Total',
            type: typeNumber,
            selector: "total",
            flexGrow: 1,
            cell: row => <span style={spanStyle}>{row.total}$</span>
        },
        {
            name: 'Status',
            type: typeString,
            selector: "paid",
            flexGrow: 1,
            cell: row => <span style={spanStyle}>{row.paid ? 'Complete' : 'Pending' }</span>
        },
    ]
    if (!props.dataAll) {
        return <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', marginTop: 200 }}>
        </div>
    }

    return <div className='data-list simple' style={{ marginTop: 30 }}>
        <span style={{ fontSize: '1.5rem', marginLeft: '3px', fontWeight: 500 }}>Payments</span>
        <DataTable
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationComponent={() => (
                <ReactPaginate
                    previousLabel={<ChevronLeft size={15} />}
                    nextLabel={<ChevronRight size={15} />}
                    breakLabel="..."
                    breakClassName="break-me"
                    pageCount={totalPages}
                    containerClassName="vx-pagination separated-pagination pagination-end pagination-sm mb-0 mt-2"
                    activeClassName="active"
                    initialPage={page}
                    onPageChange={page => setPage(page.selected)}
                />
            )}
            noHeader
            responsive
            sortIcon={<ChevronDown />}
            sortServer
            onSort={handleSort}
        />
    </div>
}

const mapStateToProps = state => {
    return {
        user: state.app.user?.user,
        token: tokenSelector(state)
    }
}

export default connect(mapStateToProps)(AffiliatePagePayments)